import { branch } from 'recompose';
import Component from './DraggableProfileHero';
import Container from './DraggableProfileHero.container';

export default Container(
  branch(
    props => !props.coverDeviation,
    () => null
  )(Component)
);
